var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import mixpanel from 'mixpanel-browser';
var MixpanelService = /** @class */ (function () {
    function MixpanelService() {
        this.enabled = false;
        if (process.env.NODE_ENV !== 'production') {
            // console.warn("Mixpanel disabled in development")
            return;
        }
        if (!process.env.REACT_APP_MIXPANEL_TOKEN) {
            console.warn('Mixpanel token is missing');
            return;
        }
        mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, { debug: process.env.REACT_APP_MIXPANEL_DEBUG == 'true' });
        this.enabled = true;
    }
    MixpanelService.getInstance = function () {
        if (!MixpanelService.instance) {
            MixpanelService.instance = new MixpanelService();
        }
        return MixpanelService.instance;
    };
    MixpanelService.prototype.identify = function (options) {
        if (!this.enabled)
            return;
        mixpanel.identify(options.distinctId || options.userId);
        mixpanel.people.set({ $distinct_id: options.userId });
    };
    MixpanelService.prototype.track = function (event, properties) {
        if (!this.enabled)
            return;
        this.sendData(function () { return mixpanel.track(event, properties); });
        if (process.env.REACT_APP_MIXPANEL_DEBUG == 'true') {
            console.log("Mixpanel track: ".concat(event), properties);
        }
    };
    MixpanelService.prototype.trackScreenVisit = function (screenName, eventParams) {
        var _this = this;
        if (eventParams === void 0) { eventParams = {}; }
        if (!this.enabled)
            return;
        this.sendData(function () {
            var _a;
            return _this.track('screen visited', __assign((_a = {}, _a['screen name'] = screenName, _a), eventParams));
        });
        // this.sendData(() => this.increment({
        //     "total number of screens visited": 1,
        // }))
        // this.sendData(() => this.setPeopleProperties({
        //     "last screen visited": screenName
        // }))
        if (process.env.REACT_APP_MIXPANEL_DEBUG == 'true') {
            console.log("Mixpanel screen visited: ".concat(screenName));
        }
    };
    MixpanelService.prototype.setPeopleProperties = function (properties) {
        if (!this.enabled)
            return;
        this.sendData(function () { return mixpanel.people.set(properties); });
    };
    MixpanelService.prototype.increment = function (properties) {
        if (!this.enabled)
            return;
        this.sendData(function () { return mixpanel.people.increment(properties); });
    };
    MixpanelService.prototype.reset = function () {
        if (!this.enabled)
            return;
        this.sendData(function () { return mixpanel.reset(); });
    };
    MixpanelService.prototype.sendData = function (action) {
        if (!this.enabled)
            return;
        setTimeout(action, 0);
    };
    MixpanelService.prototype.onLogin = function (response) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (!this.enabled)
            return;
        if (response && response.user) {
            mixpanel.identify("".concat((_a = response.user) === null || _a === void 0 ? void 0 : _a.id));
            mixpanel.people.set({
                'organization': (_b = response === null || response === void 0 ? void 0 : response.organization) === null || _b === void 0 ? void 0 : _b.name,
                'organization id': (_c = response.organization) === null || _c === void 0 ? void 0 : _c.id,
                '$email': (_d = response.user) === null || _d === void 0 ? void 0 : _d.email,
                '$first_name': (_e = response === null || response === void 0 ? void 0 : response.user) === null || _e === void 0 ? void 0 : _e.firstName,
                '$last_name': (_f = response === null || response === void 0 ? void 0 : response.user) === null || _f === void 0 ? void 0 : _f.lastName,
                '$name': [(_g = response === null || response === void 0 ? void 0 : response.user) === null || _g === void 0 ? void 0 : _g.firstName, (_h = response === null || response === void 0 ? void 0 : response.user) === null || _h === void 0 ? void 0 : _h.lastName].filter(function (x) { return !!x; }).join(' ')
            });
        }
        else {
            this.reset();
        }
    };
    return MixpanelService;
}());
export { MixpanelService };
